import type { UserPermission } from "@/lib/api";
import { USER_PERMISSIONS } from "@/lib/permissions";

/** メンバーに付与する権限の選択欄。 */
export function PermissionCheckboxes({
	value,
	disabled = false,
	onChange,
}: {
	value: readonly UserPermission[];
	disabled?: boolean;
	onChange: (permissions: UserPermission[]) => void;
}) {
	return (
		<fieldset
			style={{
				margin: 0,
				padding: 0,
				border: "none",
				display: "flex",
				flexDirection: "column",
				gap: 10,
			}}
		>
			<legend
				style={{
					padding: 0,
					marginBottom: 8,
					fontSize: "var(--text-ui)",
					fontWeight: 500,
					color: "var(--fg-1)",
				}}
			>
				権限
			</legend>
			{USER_PERMISSIONS.map((permission) => (
				<label
					key={permission.value}
					style={{
						display: "flex",
						alignItems: "flex-start",
						gap: 8,
						cursor: disabled ? "default" : "pointer",
					}}
				>
					<input
						type="checkbox"
						data-testid={`permission-${permission.value}`}
						checked={value.includes(permission.value)}
						disabled={disabled}
						onChange={(e) =>
							onChange(
								e.target.checked
									? [...value, permission.value]
									: value.filter((p) => p !== permission.value),
							)
						}
						style={{
							width: 14,
							height: 14,
							margin: "3px 0 0",
							flexShrink: 0,
							accentColor: "var(--accent-solid)",
							cursor: "inherit",
						}}
					/>
					<span style={{ display: "flex", flexDirection: "column", gap: 2 }}>
						<span style={{ fontSize: "var(--text-ui)", color: "var(--fg-1)" }}>
							{permission.label}
						</span>
						<span style={{ fontSize: "var(--text-caption)", color: "var(--fg-3)" }}>
							{permission.description}
						</span>
					</span>
				</label>
			))}
		</fieldset>
	);
}
